export enum PaymentProviderType {
    PayFast,
    Google,
    Apple,
    Huawei,
    Manual,
    Nouvobanq,
    FabrikCredit
}

export enum RoleType {
    Subscription = 0,
    OnceOff = 1,
    Period = 2
}

export enum TransactionStatus {
    Successful,
    Failed
}
export enum ProductType {
    DirectTransaction,
    CreditTransaction
}
export enum CreditTransactionType {
    /// Top up transaction
    TopUp = 0,
    /// Messaging of all types transaction - used if generic
    MessagingAll = 1,
    /// Messaging of text only - used if specific, cannot be mapped same time as generic
    MessagingText = 2,
    /// Messaging of text with image - used if specific, cannot be mapped same time as generic
    MessagingImage = 3,
    /// Messaging of text with embedded url - used if specific, cannot be mapped same time as generic
    MessagingUrl = 4,
    /// Messaging of text with audio - used if specific, cannot be mapped same time as generic
    MessagingAudio = 5,
    /// Messaging of text with video  - used if specific, cannot be mapped same time as generic
    MessagingVideo = 6,
    /// Free Credits for new users - used only on account creation
    PromotionTopUp = 7,
    /// Member Service Directory Listing
    ServiceDirectory = 9
}
